export const formatDate = (value, options = {}) => {
  if (!value) return "";
  const date = value?.toDate ? value.toDate() : new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
    ...options
  }).format(date);
};

export const extractYouTubeId = (value = "") => {
  const match = value.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  return match?.[1] || "";
};

export const youtubeThumbnail = (item) => {
  if (item.imageUrl) return item.imageUrl;
  const id = item.youtubeId || extractYouTubeId(item.youtubeUrl);
  return id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : "";
};

export const shareItem = async (title, text, url = window.location.href) => {
  if (navigator.share) {
    await navigator.share({ title, text, url });
    return;
  }
  await navigator.clipboard.writeText(url);
};

export const addToCalendarUrl = (event) => {
  const start = String(event.date || "").replaceAll("-", "");
  const details = encodeURIComponent(event.description || "");
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title)}&dates=${start}/${start}&details=${details}&location=${encodeURIComponent(event.venue || "")}`;
};

export const parseParagraphs = (value = "") => String(value)
  .split(/\n\s*\n/)
  .map((paragraph) => paragraph.trim())
  .filter(Boolean);

export const parseListItems = (value = "") => String(value)
  .split("\n")
  .map((line) => line.trim())
  .filter(Boolean)
  .map((line) => {
    const [title, ...details] = line.split("|");
    return {
      title: title.trim(),
      detail: details.join("|").trim()
    };
  });

export const contentSearch = (query) => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return [];
  const routes = [
    { title: "About Satnam Satsang Ahmedabad", description: "Mission, vision, history and activities", url: "/about" },
    { title: "Upcoming satsang programmes", description: "Dates, timings and venue information", url: "/satsang" },
    { title: "Events", description: "Upcoming and past community events", url: "/events" },
    { title: "Spiritual audio", description: "Bhajans, simran and satsang discourses", url: "/audio" },
    { title: "Videos", description: "Watch satsang and bhajan recordings", url: "/videos" },
    { title: "Photo gallery", description: "Albums from programmes, festivals and seva", url: "/gallery" },
    { title: "Contact us", description: "Send a message or find our location", url: "/contact" }
  ];
  return routes.filter((item) => `${item.title} ${item.description}`.toLowerCase().includes(normalized));
};
